/**
 * NoSlotsCard — TEST 1.35 / TEST 2.08. What a patient sees where a calendar of
 * invented times used to be. The copy is chosen by the reason utils/bookableSlots.js
 * classified (scheduling-off / no-hours / none-open / fetch-failed / no-doctor), so
 * "I could not load the calendar" is never shown as "this doctor has no hours".
 *
 * Props:
 *   reason  - a bookableSlots reason (non-null)
 *   phone   - the office number, when the case knows one; offered for every reason
 *             except fetch-failed (retry first) and no-doctor (there is no office)
 *   onRetry - shown as "Try again" for fetch-failed only
 */
import { Calendar, RefreshCw } from 'lucide-react'
import { useI18n } from '../i18n'
import { noSlotsMessageKeys } from '../utils/bookableSlots'

export default function NoSlotsCard({ reason, phone, onRetry }) {
  const { t } = useI18n()
  const { title, body } = noSlotsMessageKeys(reason)
  const canCall = !!phone && reason !== 'fetch-failed' && reason !== 'no-doctor'
  return (
    <div className="mb-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-5 text-center" data-no-slots={reason}>
      <Calendar size={22} className="mx-auto mb-2 text-gray-300" />
      <p className="text-[13px] font-semibold text-gray-600 mb-1">{t(title)}</p>
      {body && <p className="text-[11px] text-gray-500">{t(body)}</p>}
      {canCall && (
        <a href={`tel:${phone}`} className="inline-block mt-2 text-[12px] font-semibold text-[#46A8F9] no-underline">
          {phone}
        </a>
      )}
      {reason === 'fetch-failed' && onRetry && (
        <button onClick={onRetry}
          className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-gray-200 bg-white text-[12px] font-semibold text-[#15354F] cursor-pointer">
          <RefreshCw size={12} /> {t('common.tryAgain')}
        </button>
      )}
    </div>
  )
}
